<template>
  <div>
    <ExpireHeader header="สินค้าส่งคืนรอย้ายเข้าคลังรอคืน" :img_header="header_image" link_back="stock/storage/expirestorage"/>
    <Refun_product/>
  </div>
</template>

<script>
import HeaderImage from '@/assets/reuse.png'
import ExpireHeader from "@/components/admin/stock/storage_expire/header_expire/ExpireHeader.vue";
import Refun_product from "@/components/admin/stock/storage_expire/Refun_product.vue";
export default {
  name: "RefunProduct",
  components: {
    Refun_product,
    ExpireHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
